module.exports = __webpack_public_path__ + "static/media/Charity Excerpt Translated by park_jihyeon.6ca3c0c7.md";